import config from '../config'

export const getParameterByName = (name) => {
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]")
    console.log('getParameterByName:', window.location);
    const regex = new RegExp("[\\#&]" + name + "=([^&#]*)"),
        results = regex.exec(window.location.search)
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

const MAX_RETRIES = 3

const fetchOnce = async (url, init) => {
    const response = await fetch(url, {
        ...init,
        headers: {
            ...init?.headers,
            'Accept': 'application/json',
            'Accept-Encoding': 'gzip, deflate'
        }
    })

    if (!response.body) {
        const text = await response.text()
        const json = text ? JSON.parse(text) : {}
        return response.ok ? json : Promise.reject(json)
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder()
    let text = ''
    while (true) {
        const { done, value } = await reader.read()
        if (done) break
        text += decoder.decode(value, { stream: !done })
    }

    const json = text ? JSON.parse(text) : {}
    return response.ok ? json : Promise.reject(json)
}

export const fetchWrapper = async (url, init) => {
    let lastError
    for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
        try {
            return await fetchOnce(url, init)
        } catch (e) {
            lastError = e
            console.warn(`fetchWrapper: Attempt ${attempt}/${MAX_RETRIES} failed for ${url}:`, e.message)
            if (attempt < MAX_RETRIES) await new Promise(r => setTimeout(r, 1000 * attempt))
        }
    }
    throw lastError
}

export const validateSubscription = (customerId, applicationId) => {
    return fetchWrapper(config.endpoints.subscription, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ customerId, applicationId })
    })
}

export const isIterable = (obj) => {
    // checks for null and undefined
    if (obj == null) {
        return false;
    }
    return typeof obj[Symbol.iterator] === 'function';
}

const mapToObj = m => {
    return Array.from(m).reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
    }, {});
};

const JSONToCSVConvertor = (JSONData, ReportTitle, ShowLabel) => {
    const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
    let CSV = 'sep=,\r\n\n'
    let row = ""
    if (ShowLabel) {
        //This loop will extract the label from 1st index of on array
        for (let index in arrData[0])
            row += index + ',';

        row = row.slice(0, -1);
        //append Label row with line break
        CSV += row + '\r\n';
    }

    //1st loop is to extract each row
    for (let i = 0; i < arrData.length; i++) {
        row = "";

        //2nd loop will extract each column and convert it in string comma-seprated
        for (let index in arrData[i])
            row += '"' + arrData[i][index] + '",';

        row.slice(0, row.length - 1);
        //add a line break after each row
        CSV += row + '\r\n';
    }

    if (CSV === '') {
        alert("Invalid data");
        return;
    }

    //Generate a file name
    ReportTitle.replace(/ /g, "_");

    //Initialize file format you want csv or xls
    const uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

    const link = document.createElement("a");
    link.href = uri;
    //set the visibility hidden so it will not effect on your web-layout
    link.style = "visibility:hidden";
    link.download = ReportTitle + ".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export default {
    isIterable,
    getParameterByName,
    fetchWrapper,
    validateSubscription,
    mapToObj,
    JSONToCSVConvertor
}